import { ApiHttpService } from '../ApiHttpService';
import { Menu } from '../../models/Menu';
import { MenuSerializer } from '../serializers/MenuSerializer';

const MENUS_PATH = 'home/menus';

class MenusController {
  static async all() {
    const response = await ApiHttpService.get(MENUS_PATH);
    return this._instantiateList(response.data);
  }

  static _instantiateList(dataList) {
    return dataList.map(this._instantiatieModel);
  }

  static _instantiatieModel(data) {
    const cleanData = MenuSerializer.deSerialize(data);
    return new Menu(cleanData);
  }
}

export { MenusController };



// WEBPACK FOOTER //
// ./src/networking/controllers/MenusController.js